<template>
  <!-- // 导航风格4-教学 -->
  <div
    class="container navigate-top"
    :class="{ hasLeft: false, collapsed: isCollapse }"
  >
    <div class="right-wrapper">
      <common-iframe
        :srcInfo="frameSrc"
        frameborder="0"
      ></common-iframe>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { autoCloseMenu } from 'utils/mixin'
import commonIframe from '../view-page/common-iframe'
export default {
  name: 'navigate-top',
  components: { commonIframe },
  props: {
    userName: String
  },
  computed: {
    ...mapGetters(['navigateSchema', 'appMenus', 'activeTabMenu']),
    activeMenu () {
      this.seekMenuRoots(this.activeTabMenu, true)
      let _menuMap = this.menuMap
      _menuMap = _menuMap.reverse()
      let _map = {
        firstMenu: null,
        secondMenu: null,
        thirdMenu: null
      }
      if (_menuMap[0]) {
        _map.firstMenu = this._getMenu(this.appMenus, _menuMap[0])
      }
      if (_map.firstMenu) {
        if (_menuMap[1]) {
          _map.secondMenu = this._getMenu(
            _map.firstMenu.children,
            _menuMap[1]
          )
        } else if (_map.firstMenu.children.length) {
          _map.secondMenu = _map.firstMenu.children[0]
        }
      }
      if (_map.secondMenu) {
        if (_menuMap[2]) {
          _map.thirdMenu = this._getMenu(
            _map.secondMenu.children,
            _menuMap[2]
          )
        } else if (_map.secondMenu.children.length) {
          _map.thirdMenu = _map.secondMenu.children[0]
        }
      }
      return _map
    },
    hasLeft () {
      return this.activeMenu.firstMenu && this.activeMenu.firstMenu._hasChild
    },
    frameSrc () {
      if (this.activeMenu.thirdMenu) {
        if (this.activeMenu.thirdMenu.openType === 2) {
          window.open(this.activeMenu.thirdMenu.fullUrl)
          this.$router.go(-1)
          return ''
        } else {
          return this.activeMenu.thirdMenu.fullUrl
        }
      }
      if (this.activeMenu.secondMenu) {
        if (this.activeMenu.secondMenu.openType === 2) {
          window.open(this.activeMenu.secondMenu.fullUrl)
          this.$router.go(-1)
          return ''
        } else {
          return this.activeMenu.secondMenu.fullUrl
        }
      }
      if (this.activeMenu.firstMenu) {
        if (this.activeMenu.firstMenu.openType === 2) {
          window.open(this.activeMenu.firstMenu.fullUrl)
          this.$router.go(-1)
          return ''
        } else {
          return this.activeMenu.firstMenu.fullUrl
        }
      }
      return ''
    },
    tlncParams () {
      return JSON.stringify(this.$storage.get('tlncParams'))
    },
    firstChildren () {
      if (this.activeMenu.firstMenu) {
        this.activeMenu.firstMenu.children.forEach(item => {
          item.children = item.fullUrl ? [] : item.children
        })
        return this.activeMenu.firstMenu.children
      } else {
        return []
      }
    }
  },
  data () {
    return {
      defaultIcon: `this.src="${require('../../assets/images/nav_icondefault_B.png')}"`,
      isCollapse: false,
      menuMap: []
    }
  },
  watch: {
    '$route.params' () {
      this._selectMenu()
    }
  },
  methods: {
    seekMenuRoots (_value, flag) {
      if (flag) this.menuMap = []
      const findMenu = (arr, value, key) => {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i][key] === value) {
            return arr[i]
          }
          if (arr[i]._hasChild) {
            let _res = findMenu(arr[i].children, value, key)
            if (_res) return _res
          }
        }
        return null
      }
      let menu = findMenu(this.appMenus, _value, 'menuId')
      if (menu) {
        this.menuMap.push(menu.menuId || '')
        if (menu.parentId !== 'menu_app') {
          this.seekMenuRoots(menu.parentId)
        }
      }
    },
    _getMenu (arr, id) {
      let _menu = null
      if (!arr || arr.length < 0 || !id) return _menu
      arr.forEach(item => {
        if (item.menuId === id) {
          _menu = item
        }
      })
      return _menu
    },
    _selectMenu () {
      this.$nextTick(() => {
        let _selected = ''
        let _arr = []
        if (this.activeMenu.thirdMenu) {
          _selected = this.activeMenu.thirdMenu._path
          _arr = [this.activeMenu.secondMenu._path]
        } else if (this.activeMenu.secondMenu) {
          _selected = this.activeMenu.secondMenu._path
        }
        if (this.$refs.leftMenu) {
          this.$refs.leftMenu.activeIndex = _selected
          this.$refs.leftMenu.openedMenus = _arr
        }
      })
    },
    onClickCollapseBtn (flag) {
      if (flag) {
        this.isCollapse = flag
      } else {
        this.isCollapse = !this.isCollapse
      }
    }
  },
  mounted () {
    this._selectMenu()
    this._autoCloseMenu()
    top.window.extendScreen_closeMenu = this.onClickCollapseBtn
  },
  mixins: [autoCloseMenu]
}
</script>

<style lang="scss" scoped>
.container.navigate-top {
  width: 100%;
  height: 100%;
  .right-wrapper {
    width: 100%;
    height: 100%;
  }
}
</style>
